module.exports = __webpack_public_path__ + "img/thumb_2020-01.d378be99.jpg";